import _callApi from "../../services/baseService";
import { END_POINT } from "../../constants/ApiEndPoints";
import { InspectJobsActions } from "../actions/InspectJobsAction";


export const GetAJob = ({form})=>{

    return (dispatch, getState)=>{

        dispatch(InspectJobsActions.InspJobDetailGetting({result:{},error:{}}))
        let url = END_POINT.INSPECTION_JOB_DETAIL.END_POINT;
        if(form.reportID){
            url += `?reportID=${form.reportID}`;
        }
        return _callApi(
            form,
            url,
            END_POINT.INSPECTION_JOB_DETAIL.POST
        ).then(res=>{
            let { error=null, result=null } = res.data

            if(error){
                
                dispatch(InspectJobsActions.InspJobDetailFailed({result,error}))

            }else{

                dispatch(InspectJobsActions.InspJobDetailGot({result,error}))

            }
        })
    }

}